import { Components, Theme } from "@mui/material";

export const MuiInputLabel: Components<
  Omit<Theme, "MuiInputLabel">
>["MuiInputLabel"] = {
  styleOverrides: {
    root: ({ theme: { spacing } }) => ({
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "14px",
      paddingTop: spacing(0.25),

      "&.MuiInputLabel-shrink": {
        fontSize: 14,
        lineHeight: "15.6px",

        color: "#00000080",
        paddingLeft: spacing(1),
        marginTop: 16,
      },
    }),
  },
};
